import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const initiativeList = 'okr/find?page=1&page_size=100&filter[okr_type]=northstar_objective&filter[assignment_as]=initiative';
const initiativeDetail = 'okr/detail/';
const initiativeListTeam = 'okr/find?page=1&page_size=100&filter[okr_type]=northstar_objective&filter[assignment_as]=initiative&filter[assignment_type]=team';
const initiativeListDepartment = 'okr/find?page=1&page_size=100&filter[okr_type]=northstar_objective&filter[assignment_as]=initiative&filter[assignment_type]=department';

export const apiInitiativeList = async (val) => {
  let url = `${URL_V2 + initiativeList}&filter[status]=active`;
  if (val === 'employee') {
    url = `${URL_V2 + initiativeList}&filter[myokr]=true&filter[status]=active`;
  } else if (val !== undefined) {
    url = `${URL_V2 + initiativeList + val}`;
  } else if (val === undefined) {
    url = `${`${URL_V2 + initiativeList}&filter[status]=active`}`;
  }

  const datas = await http.get(`${url}`);
  return datas.data.data;
};

export const apiInitiativeDetail = async (id) => {
  const datas = await http.get(`${URL_V2 + initiativeDetail + id}`);
  return datas.data.data;
};
export const apiInitiativeListTeam = async () => {
  const datas = await http.get(`${URL_V2 + initiativeListTeam}`);
  return datas.data.data;
};
export const apiInitiativeListDepartment = async () => {
  const datas = await http.get(`${URL_V2 + initiativeListDepartment}`);
  return datas.data.data;
};
